/*eslint no-var: 0*/
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFunctions } from 'firebase/functions';
import { getAuth } from "firebase/auth"
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

import * as firebaseui from "firebaseui";
import FirebaseConfig from "_manager/firebase-config";
import CONFIG from "config/config";


const isMehealthAndDev = () => {
  // if () {
  //   if (config?.measurementId) {
  //     delete config.measurementId;
  //   }
  // }
  return process.env.NODE_ENV === "development" && CONFIG.COMPANY === "MEHEALTH";
};


let appFirebase

 if (!CONFIG?.OFFLINE) { 
  if (!getApps().length) {
    console.log("Firebase: !!!! src/react-lib/frameworks/Firebase.ts ");
  
    let firebase_project = CONFIG.FIREBASE_PROJECT;
    console.log("Firebase: CONFIG: ", CONFIG);
    if (firebase_project === "") {
      console.error("Firebase: Not config FIREBASE_PROJECT in base.json");
    }
  
    console.log("Firebase: firebaseConfig: ", FirebaseConfig);

    if (Array.isArray(FirebaseConfig)) {
      
      var fconfig = undefined 
      var fconfigList = FirebaseConfig.filter((item: any) => item.projectId === firebase_project);
      if (fconfigList?.length === 1) {
        fconfig = fconfigList[0]
      } else if ( fconfigList?.length > 1 ) { 
        fconfig = fconfigList.find((item: any) => item.webAppName === CONFIG.FIREBASE_WEBAPP_NAME)
      }
      console.log("Firebase: config: ", fconfig);
      if (fconfig) {
        // fconfig = removeMeasurementId(fconfig)
        appFirebase = initializeApp(fconfig);
      } else {
        console.error("Firebase: Can't find suitable config, then use first");
        // fconfig = removeMeasurementId(FirebaseConfig[0])
        appFirebase = initializeApp(fconfig);
      }
    } else {
      // backward complatible ไม่ใช่ Array
      console.log('Firebase: backward complatible FirebaseConfig: ', FirebaseConfig);
      // fconfig = removeMeasurementId(FirebaseConfig)
      appFirebase = initializeApp(fconfig);
    }
  } else {
    console.log('Firebase: Already iniitial Firebase called getApp()');
    appFirebase = getApp()
  }
}

console.log("Firebase: CONFIG?.OFFLINE", CONFIG?.OFFLINE)
console.log('Firebase: CONFIG.FIREBASE_DB_NAME: ', CONFIG.FIREBASE_DB_NAME);
console.log("Firebase: CONFIG", CONFIG)

export const firebaseApp = appFirebase

// export { default as app } from "firebase/compat/app";
export const app = appFirebase
const specificDBName = CONFIG.FIREBASE_DB_NAME !== "(default)" && CONFIG.FIREBASE_DB_NAME !== "" 
console.log('Firebase:  specificDBName: ', specificDBName);
export const db = !CONFIG?.OFFLINE && appFirebase ? ( specificDBName ? getFirestore(appFirebase, CONFIG.FIREBASE_DB_NAME) : getFirestore(appFirebase)) : null;
export const analytics = !CONFIG?.OFFLINE && firebaseApp &&  !isMehealthAndDev() ? getAnalytics(firebaseApp): null;
export const functions = !CONFIG?.OFFLINE ? fconfig?.functionRegion ? getFunctions(appFirebase, fconfig?.functionRegion) : getFunctions(appFirebase) : null;
export const storage = !CONFIG?.OFFLINE ? getStorage(firebaseApp) : null;
export const auth = !CONFIG?.OFFLINE ? getAuth(firebaseApp) : null;
export const ui = !CONFIG?.OFFLINE && auth ? new firebaseui.auth.AuthUI(auth) : null;
// ถ้า Function อยู่ที่ ต่าง region จะใช้ 
// export var functions: firebase.functions.Functions | undefined | null = !CONFIG?.OFFLINE ? firebaseApp?.functions('asia-east1') : null; 